import { FelaCSS, colors, spacing } from '@bridebook/ui';

interface IStyleProps {
  hasSomethingToShow: boolean;
  isWeddingFairs?: boolean;
  isLoggedIn?: boolean;
}

interface IStyles {
  testimonialsWrap: FelaCSS;
  sectionWrap: FelaCSS;
  contentWrap: FelaCSS;
  listWrap: FelaCSS;
  reviewWrap: FelaCSS;
}

const styles = ({ hasSomethingToShow, isLoggedIn }: IStyleProps): IStyles => ({
  testimonialsWrap: {
    paddingTop: isLoggedIn ? 0 : spacing[4],
  },

  sectionWrap: {
    paddingTop: spacing[4],
    paddingBottom: spacing[2],

    maxWidthTabletSm: {
      paddingBottom: hasSomethingToShow ? 0 : spacing[4],
    },
  },

  contentWrap: {
    maxWidthTabletSm: {
      marginTop: spacing[4],
      padding: spacing[4],
      backgroundColor: colors.space04,
    },
  },

  listWrap: {
    marginBottom: spacing[6],
  },

  reviewWrap: {
    ':not(:last-of-type)': {
      marginBottom: spacing[4],
    },
  },
});

export default styles;
